"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Code_exports = {};
__export(Code_exports, {
  default: () => Code_default
});
module.exports = __toCommonJS(Code_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.74609 13.4922C7.91536 13.6615 8 13.8633 8 14.0977C8 14.319 7.91536 14.5078 7.74609 14.6641C7.58984 14.8333 7.39453 14.918 7.16016 14.918C6.9388 14.918 6.74349 14.8333 6.57422 14.6641L2.76562 10.8359C2.59635 10.6797 2.51172 10.4844 2.51172 10.25C2.51172 10.0156 2.59635 9.82031 2.76562 9.66406L6.57422 5.83594C6.74349 5.66667 6.9388 5.58203 7.16016 5.58203C7.39453 5.58203 7.58984 5.66667 7.74609 5.83594C7.91536 5.99219 8 6.1875 8 6.42188C8 6.64323 7.91536 6.83854 7.74609 7.00781L4.50391 10.25L7.74609 13.4922ZM16.4961 10.25L13.2539 7.00781C13.0846 6.83854 13 6.64323 13 6.42188C13 6.1875 13.0846 5.99219 13.2539 5.83594C13.4102 5.66667 13.599 5.58203 13.8203 5.58203C14.0547 5.58203 14.2565 5.66667 14.4258 5.83594L18.2344 9.66406C18.4036 9.82031 18.4883 10.0156 18.4883 10.25C18.4883 10.4844 18.4036 10.6797 18.2344 10.8359L14.4258 14.6641C14.2565 14.8333 14.0547 14.918 13.8203 14.918C13.599 14.918 13.4102 14.8333 13.2539 14.6641C13.0846 14.5078 13 14.319 13 14.0977C13 13.8633 13.0846 13.6615 13.2539 13.4922L16.4961 10.25Z",
      fill: "currentColor"
    }
  )
);
const SvgCode = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Code_default = SvgCode;
